'use strict';

module.exports = require('./lib').PhoneNumber;
Object.defineProperty(module.exports, "__esModule", {
  value: true
});
module.exports["default"] = module.exports;